"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _bash = _interopRequireDefault(require("highlight.js/lib/languages/bash"));

var _default = _bash.default;
exports.default = _default;